import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import s from './radioGroup.module.scss';
export var RadioGroup = function (_a) {
    var choices = _a.choices, _b = _a.name, name = _b === void 0 ? 'radio-group' : _b, onChange = _a.onChange;
    var _c = useState(choices[0]), selected = _c[0], setSelected = _c[1];
    var handleChange = function (value) {
        setSelected(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    return (_jsx("div", { className: s.radioGroup, children: choices.map(function (choice) { return (_jsxs("label", { className: s.radio, children: [_jsx("input", { type: 'radio', name: name, value: choice, checked: selected === choice, onChange: function () { return handleChange(choice); } }), _jsx("span", { className: s.custom }), choice] }, choice)); }) }));
};
